import Icon from 'veui/components/Icon'

Icon.register({
  calendar: {
    paths: [
      {
        d: 'M34.5 8v2a2 2 0 11-4 0V8h-13v2a2 2 0 11-4 0V8H6a2 2 0 00-2 2v7.5h40V10a2 2 0 00-2-2h-7.5zm0-4H42a6 6 0 016 6v32a6 6 0 01-6 6H6a6 6 0 01-6-6V10a6 6 0 016-6h7.5V2a2 2 0 114 0v2h13V2a2 2 0 114 0v2zM4 21.5V42c0 1.1.9 2 2 2h36a2 2 0 002-2V21.5H4zm12 10a2 2 0 110-4h16a2 2 0 110 4H16zm0 7a2 2 0 110-4h16a2 2 0 110 4H16z'
      }
    ],
    width: '48',
    height: '48'
  }
})
